import { render } from "./agregarAdministrador.vue?vue&type=template&id=2f8dc69e&scoped=true"
import script from "./agregarAdministrador.vue?vue&type=script&lang=js"
export * from "./agregarAdministrador.vue?vue&type=script&lang=js"

import "./agregarAdministrador.vue?vue&type=style&index=0&id=2f8dc69e&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\reclasin-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f8dc69e"]])

export default __exports__